'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var utils = require('@egds/react-core/utils');

/* istanbul ignore file */
var ThirdPartyAdapter = /*#__PURE__*/function () {
  function ThirdPartyAdapter(locale) {
    _classCallCheck(this, ThirdPartyAdapter);
    _defineProperty(this, "locale", void 0);
    _defineProperty(this, "category", void 0);
    _defineProperty(this, "sourceName", void 0);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "apiKey", void 0);
    _defineProperty(this, "version", void 0);
    this.locale = locale;
  }
  return _createClass(ThirdPartyAdapter, [{
    key: "toEssResult",
    value: function toEssResult(predictionDescription, placeId, index) {
      var displayName = predictionDescription;
      var primaryDisplayName = '';
      var secondaryDisplayName = '';
      var parts = (displayName || '').split(',');
      if (parts.length < 2) {
        primaryDisplayName = parts[0].trim();
      } else {
        primaryDisplayName = parts[0];
        secondaryDisplayName = parts.slice(1).map(function (word) {
          return word.trim();
        }).join(', ').trim();
      }
      return {
        category: this.category,
        coordinates: undefined,
        index: index,
        regionNames: {
          displayName: displayName,
          fullName: predictionDescription,
          lastSearchName: predictionDescription,
          primaryDisplayName: primaryDisplayName,
          secondaryDisplayName: secondaryDisplayName
        },
        sourceId: placeId,
        sourceName: this.sourceName,
        type: this.type
      };
    }
  }]);
}();
/* istanbul ignore file */
var GOOGLEMAPS_CATEGORY = 'GOOGLEMAPS';
exports.PlacesServiceStatus = void 0;
(function (PlacesServiceStatus) {
  PlacesServiceStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
  PlacesServiceStatus["OK"] = "OK";
  PlacesServiceStatus["OVER_QUERY_LIMIT"] = "OVER_QUERY_LIMIT";
  PlacesServiceStatus["REQUEST_DENIED"] = "REQUEST_DENIED";
  PlacesServiceStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  PlacesServiceStatus["ZERO_RESULTS"] = "ZERO_RESULTS";
})(exports.PlacesServiceStatus || (exports.PlacesServiceStatus = {}));
var GoogleAdapter = /*#__PURE__*/function (_ThirdPartyAdapter2) {
  function GoogleAdapter(locale, apiKey, version) {
    var _this;
    _classCallCheck(this, GoogleAdapter);
    _this = _callSuper(this, GoogleAdapter, [locale]);
    _defineProperty(_this, "google", void 0);
    _defineProperty(_this, "googleAutoCompleteService", void 0);
    _defineProperty(_this, "placesService", void 0);
    _defineProperty(_this, "ready", void 0);
    _this.category = GOOGLEMAPS_CATEGORY;
    _this.sourceName = 'GPA';
    _this.type = 'ADDRESS';
    _this.version = version;
    var conf = {
      accessToken: apiKey,
      locale: locale,
      version: version
    };
    var timeoutDuration = 10000;
    var timeoutPromise = new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error('Timeout: Map API initialization took too long'));
      }, timeoutDuration);
    });
    _this.ready = Promise.race([utils.initGoogleMapsApi(false, conf, false), timeoutPromise]).then(function () {
      _this.google = window.google;
      _this.initGooglePlacesService();
      return true;
    })["catch"](function (err) {
      console.error(err);
      return false;
    });
    return _this;
  }
  _inherits(GoogleAdapter, _ThirdPartyAdapter2);
  return _createClass(GoogleAdapter, [{
    key: "isReady",
    value: function isReady() {
      return this.ready;
    }
  }, {
    key: "initGooglePlacesService",
    value: function initGooglePlacesService() {
      if (this.google && this.google.maps && this.google.maps.places) {
        var _this$google$maps$pla = this.google.maps.places,
          AutocompleteService = _this$google$maps$pla.AutocompleteService,
          PlacesService = _this$google$maps$pla.PlacesService;
        this.googleAutoCompleteService = new AutocompleteService();
        this.placesService = new PlacesService(document.createElement('div'));
      }
    }
  }, {
    key: "fetchResults",
    value: function fetchResults(essResponse) {
      var _this2 = this;
      var request = {
        input: essResponse.q,
        type: essResponse.rc === 'ADDRESS_AUTOCOMPLETE' ? ['geocode'] : undefined
      };
      var toEssResponse = function toEssResponse(results) {
        return {
          q: essResponse.q,
          rc: essResponse.rc,
          rid: essResponse.rid,
          sr: results
        };
      };
      return new Promise(function (resolve) {
        if (_this2.googleAutoCompleteService) {
          _this2.googleAutoCompleteService.getPlacePredictions(request, function (predictions, status) {
            if (status === exports.PlacesServiceStatus.OK) {
              var response = toEssResponse(_this2.handleResponse(predictions));
              resolve(response);
            } else {
              resolve(essResponse);
            }
          });
        } else {
          resolve(essResponse);
        }
      });
    }
  }, {
    key: "fetchLocation",
    value: function fetchLocation(placeId) {
      var _this3 = this;
      return this.isReady().then(function (isReady) {
        return new Promise(function (resolve, reject) {
          if (!isReady === false) {
            try {
              var request = {
                placeId: placeId,
                fields: ['geometry']
              };
              _this3.placesService.getDetails(request, function (place, status) {
                if (status === exports.PlacesServiceStatus.OK) {
                  var _place$geometry;
                  var loc = place === null || place === void 0 || (_place$geometry = place.geometry) === null || _place$geometry === void 0 ? void 0 : _place$geometry.location;
                  if (loc) resolve({
                    lat: loc.lat().toFixed(5),
                    lng: loc.lng().toFixed(5)
                  });else resolve(undefined);
                } else if (status === exports.PlacesServiceStatus.ZERO_RESULTS) resolve(undefined);else reject(new Error("Failed to fetch location for placeId ".concat(placeId, ": ").concat(status)));
              });
            } catch (error) {
              reject(new Error("Failed to fetch location for placeId ".concat(placeId, ": ").concat(error.message)));
            }
          } else {
            reject(new Error("Unable to fetch location for placeId ".concat(placeId, ": PlacesService is not initialized")));
          }
        });
      });
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(predictions) {
      var _this4 = this;
      var results = [];
      predictions.forEach(function (prediction, index) {
        results.push(_this4.toEssResult(prediction.description, prediction.place_id, index));
      });
      return results;
    }
  }], [{
    key: "getInstance",
    value: function getInstance(locale, apiKey, version) {
      var thisLocale = locale || 'en_US';
      var thisGoogleApiKey = apiKey || 'AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68';
      if (!(thisLocale in this.instances)) {
        this.instances[thisLocale] = new GoogleAdapter(thisLocale, thisGoogleApiKey, version);
      }
      return this.instances[thisLocale];
    }
  }]);
}(ThirdPartyAdapter);
/* istanbul ignore file */
_defineProperty(GoogleAdapter, "instances", {});
var thirdPartyAdapterRegister = {
  google: GoogleAdapter
};
var ThirdPartyAdapterFactory = /*#__PURE__*/function () {
  function ThirdPartyAdapterFactory() {
    _classCallCheck(this, ThirdPartyAdapterFactory);
  }
  return _createClass(ThirdPartyAdapterFactory, null, [{
    key: "getInstance",
    value: function getInstance(k, locale, apiKey, version) {
      return thirdPartyAdapterRegister[k].getInstance(locale, apiKey, version);
    }
  }, {
    key: "filterThirdPartyAdapterFromEssConfig",
    value: function filterThirdPartyAdapterFromEssConfig(configFeaturesList) {
      return configFeaturesList.filter(function (v) {
        return v in thirdPartyAdapterRegister;
      });
    }
  }]);
}();
exports.TypeaheadLocationType = void 0;
(function (TypeaheadLocationType) {
  TypeaheadLocationType["HOTEL"] = "HOTEL";
  TypeaheadLocationType["AIRPORT"] = "AIRPORT";
  TypeaheadLocationType["MULTICITY"] = "MULTICITY";
  TypeaheadLocationType["POI"] = "POI";
  TypeaheadLocationType["METROCODE"] = "METROCODE";
  TypeaheadLocationType["METROSTATION"] = "METROSTATION";
  TypeaheadLocationType["TRAINSTATION"] = "TRAINSTATION";
  TypeaheadLocationType["ADDRESS"] = "ADDRESS";
  TypeaheadLocationType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  TypeaheadLocationType["CURRENT_LOCATION"] = "CURRENT_LOCATION";
  TypeaheadLocationType["PREMISE"] = "PREMISE";
  TypeaheadLocationType["BUSSTATION"] = "BUSSTATION";
  TypeaheadLocationType["ACTIVITY"] = "ACTIVITY";
  TypeaheadLocationType["ATTRACTION"] = "ATTRACTION";
  TypeaheadLocationType["CITY"] = "CITY";
})(exports.TypeaheadLocationType || (exports.TypeaheadLocationType = {}));
var EssFeatures;
(function (EssFeatures) {
  EssFeatures["GOOGLE"] = "google";
  EssFeatures["CONSISTENT_DISPLAY"] = "consistent_display";
})(EssFeatures || (EssFeatures = {}));
var ESSAdapter = /*#__PURE__*/function () {
  function ESSAdapter(config) {
    _classCallCheck(this, ESSAdapter);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "thirdPartyFallbackAdapter", void 0);
    _defineProperty(this, "l10n", void 0);
    _defineProperty(this, "viewSize", 0);
    _defineProperty(this, "ESSCategories", void 0);
    _defineProperty(this, "isGeoLocationAllowed", true);
    _defineProperty(this, "response", void 0);
    this.config = config;
    this.config.getDevice = this.getDevice;
  }
  return _createClass(ESSAdapter, [{
    key: "setTypeaheadCategories",
    value: function setTypeaheadCategories() {
      var formatText = this.l10n.formatText;
      this.ESSCategories = {
        ACTIVITY: formatText('typeahead.ess.attraction'),
        ADDRESS: formatText('typeahead.ess.address'),
        AIRPORT: formatText('typeahead.ess.airport'),
        ATTRACTION: formatText('typeahead.ess.attraction'),
        BUSSTATION: formatText('typeahead.ess.transit'),
        CITY: formatText('typeahead.ess.city'),
        HOTEL: formatText('typeahead.ess.hotel'),
        LISTING: formatText('typeahead.ess.property'),
        METROCODE: formatText('typeahead.ess.city'),
        METROSTATION: formatText('typeahead.ess.transit'),
        MULTICITY: formatText('typeahead.ess.city'),
        MULTIREGION: formatText('typeahead.ess.city'),
        NEIGHBORHOOD: formatText('typeahead.ess.city'),
        POI: formatText('typeahead.ess.attraction'),
        PREMISE: formatText('typeahead.ess.property'),
        TRAINSTATION: formatText('typeahead.ess.transit'),
        CURRENT_LOCATION: ''
      };
    }
  }, {
    key: "isHistoryDetailEnabled",
    value: function isHistoryDetailEnabled() {
      return this.config.historyDetail === true;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "getTypeaheadCategories",
    value: function getTypeaheadCategories() {
      return this.ESSCategories;
    }
  }, {
    key: "addToESSCategories",
    value: function addToESSCategories(newCategory) {
      this.ESSCategories = _objectSpread(_objectSpread({}, this.ESSCategories), newCategory);
    }
  }, {
    key: "setL10n",
    value: function setL10n(l10n) {
      this.l10n = l10n;
    }
  }, {
    key: "createURLParams",
    value: function createURLParams(params) {
      return Object.entries(params).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];
        return "".concat(key, "=").concat(encodeURIComponent(val));
      }).join('&');
    }
  }, {
    key: "fetchDeleteRecentSearch",
    value: function fetchDeleteRecentSearch(regionId) {
      var domain = this.config.domain.endsWith('/') ? this.config.domain : "".concat(this.config.domain, "/");
      var baseURL = "".concat(domain, "api/v1/deletehistory");
      var config = {
        lob: this.config.lob,
        locale: this.config.locale,
        guid: this.config.guid,
        expuserid: this.config.expuserid,
        siteId: this.config.siteId,
        dest: this.config.dest
      };
      var url = "".concat(baseURL, "?").concat(this.createURLParams(config));
      var headers = new Headers({
        accept: 'application/json',
        'Content-Type': 'application/json'
      });
      if (regionId !== '') {
        var body = {
          gaiaIds: [regionId]
        };
        return fetch(url, {
          body: JSON.stringify(body),
          headers: headers,
          method: 'POST'
        }).then(function (response) {
          return response.json();
        })["catch"](function (error) {
          console.error("Error while deleting recent searches: ".concat(error));
        });
      }
      return Promise.resolve([]);
    }
  }, {
    key: "constructURL",
    value: function constructURL(query, makeAltDestCall) {
      var _this5 = this;
      var domain = this.config.domain ? this.config.domain : '';
      domain = domain.endsWith('/') ? domain : "".concat(domain, "/");
      if (domain.endsWith('/')) {
        domain = domain.slice(0, -1);
      }
      var getBaseURL = function getBaseURL() {
        switch (_this5.config.domainId) {
          case 'AIRLINE':
            return "".concat(domain, "/api/v2/suggest");
          default:
            return "".concat(domain, "/api/v4/typeahead");
        }
      };
      var baseURL = getBaseURL();
      if (typeof this.config.browser === 'undefined' || this.config.browser === null) {
        this.config.browser = this.getBrowser(window.navigator.userAgent);
      }
      if (typeof this.config.device === 'undefined' || this.config.device === null) {
        this.config.device = this.getDevice(window.navigator.userAgent);
      }
      if (this.config.domainId === 'AIRLINE') {
        var configV2 = {
          domainId: this.config.domainId,
          lob: this.config.lob,
          maxResults: this.config.maxResults,
          siteid: this.config.siteId,
          locale: this.config.locale
        };
        return "".concat(baseURL, "?query=").concat(query, "&").concat(this.createURLParams(configV2));
      }
      var config = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        browser: this.config.browser,
        client: this.config.client,
        dest: this.config.dest,
        device: this.config.device,
        expuserid: this.config.expuserid ? this.config.expuserid : -1,
        features: this.config.features,
        format: 'json',
        guid: this.config.guid,
        listing: !!this.config.listing,
        lob: this.config.lob,
        locale: this.config.locale,
        maxresults: this.config.maxResults,
        personalize: this.config.personalize ? this.config.personalize : false
      }, this.config.regionId ? {
        rid: this.config.regionId
      } : {}), {}, {
        regiontype: this.config.regionType,
        siteid: this.config.siteId,
        ignorePrefillSearchTermForAlternateDestinationsRequest: this.config.ignorePrefillSearchTermForAlternateDestinationsRequest
      }, this.config.packageType ? {
        pt: this.config.packageType
      } : {}), this.config.latLong ? {
        latlong: this.config.latLong
      } : {}), this.config.lastSearchRegionId ? {
        lsrid: this.config.lastSearchRegionId
      } : {}), this.config.lastSearchTimestamp ? {
        lstime: this.config.lastSearchTimestamp
      } : {}), this.config.lastSearchLatLong ? {
        lslatlong: this.config.lastSearchLatLong
      } : {}), this.config.lastSearchElapseTime ? {
        lsetime: this.config.lastSearchElapseTime
      } : {}), this.config.googleApiKey ? {
        googleApiKey: this.config.googleApiKey
      } : {}), this.config.googleApiVersion ? {
        googleApiVersion: this.config.googleApiVersion
      } : {}), this.config.alternate && !!makeAltDestCall ? {
        alternate: true
      } : {}), this.config.debounceVariant ? {
        ab: this.config.debounceVariant
      } : {}), this.config.trending ? {
        trending: this.config.trending
      } : {}), this.config.alternateSecondVariant ? {
        alternateSecondVariant: this.config.alternateSecondVariant
      } : {}), this.config.drivable ? {
        drivable: this.config.drivable
      } : {}), this.config.fetchLocation ? {
        fetchLocation: this.config.fetchLocation
      } : {}), this.config.popularFilter ? {
        popularFilter: this.config.popularFilter
      } : {});
      var url = query === '' ? "".concat(baseURL, "/?").concat(this.createURLParams(config)) : "".concat(baseURL, "/").concat(query, "?").concat(this.createURLParams(config));
      return url;
    }
  }, {
    key: "fetchResponse",
    value: function fetchResponse(term, makeAltDestCall) {
      var personalize = this.config && this.config.personalize;
      if (term === '' && personalize || term !== '') {
        var _this$config$logReque, _this$config;
        (_this$config$logReque = (_this$config = this.config).logRequest) === null || _this$config$logReque === void 0 || _this$config$logReque.call(_this$config, term);
        return fetch(this.constructURL(term, makeAltDestCall), _objectSpread({
          method: this.config.domainId === 'AIRLINE' ? 'POST' : 'GET'
        }, this.config.xPageId && {
          headers: {
            'x-page-id': this.config.xPageId
          }
        })).then(function (response) {
          return response.json();
        });
      }
      return Promise.resolve([]);
    }
  }, {
    key: "fetchResults",
    value: function fetchResults(term, makeAltDestCall) {
      var _this6 = this;
      var searchTerm = makeAltDestCall ? '' : term;
      return this.fetchResponse(searchTerm, makeAltDestCall).then(function (json) {
        return _this6.handleEssResponse(json);
      }).then(function (json) {
        return _this6.logResponse(json);
      }).then(function (json) {
        return _this6.adaptResponseToTypeaheadResults(json, searchTerm, _this6.config.historyDetail, _this6.config.historyDetailFormatVariant);
      }).then(function (json) {
        return _this6.categorizeOnFocusResponse(json, makeAltDestCall);
      });
    }
  }, {
    key: "fetchRecentSearchResults",
    value: function fetchRecentSearchResults() {
      return this.fetchResults('');
    }
  }, {
    key: "fetchAlternativeResults",
    value: function fetchAlternativeResults(term) {
      return this.fetchResults(term, this.config.alternate || this.config.ignorePrefillSearchTermForAlternateDestinationsRequest);
    }
  }, {
    key: "fetchResultsCategorized",
    value: function fetchResultsCategorized(term) {
      var _this7 = this;
      return this.fetchResponse(term).then(function (json) {
        return _this7.handleEssResponse(json);
      }).then(function (json) {
        return _this7.logResponse(json);
      }).then(function (json) {
        return _this7.adaptResponseToTypeaheadResults(json, term, _this7.config.historyDetail, _this7.config.historyDetailFormatVariant);
      }).then(function (json) {
        return _this7.categorizeResponse(json);
      });
    }
  }, {
    key: "fetchRecentSearchResultsCategorized",
    value: function fetchRecentSearchResultsCategorized() {
      return this.fetchResultsCategorized('');
    }
  }, {
    key: "categorizeResponse",
    value: function categorizeResponse(typeaheadResults) {
      var _this8 = this;
      var resultsByCategory = new Map();
      var finalResults = [];
      var trueIndex = 0;
      if (typeaheadResults && typeaheadResults.length > 0) {
        // Creating categories and inserting to a map
        typeaheadResults.forEach(function (element) {
          var _element$data;
          var categoryName = element !== null && element !== void 0 && (_element$data = element.data) !== null && _element$data !== void 0 && _element$data.type ? _this8.ESSCategories[element.data.type] : '';
          if (!resultsByCategory[categoryName]) {
            resultsByCategory[categoryName] = [];
          }
          resultsByCategory[categoryName].push(element);
        });
        for (var _i = 0, _Object$entries = Object.entries(resultsByCategory); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            heading = _Object$entries$_i[0],
            results = _Object$entries$_i[1];
          // Pushing to an array of CategorizedResults
          // eslint-disable-next-line no-loop-func
          results.forEach(function (typeaheadResult) {
            // eslint-disable-next-line no-param-reassign
            typeaheadResult.data.index = trueIndex;
            // eslint-disable-next-line no-plusplus
            trueIndex++;
          });
          var resultByCategory = {
            heading: heading,
            typeaheadResults: results
          };
          finalResults.push(resultByCategory);
        }
      }
      return finalResults;
    }
  }, {
    key: "onFocusCategories",
    value: function onFocusCategories() {
      var formatText = this.l10n.formatText;
      return _objectSpread({
        CURRENTLOCATION: '',
        POPULAR: formatText('typeahead.ess.popular') || 'Explore popular destinations',
        DRIVABLE: formatText('typeahead.ess.nearby') || 'Nearby locations'
      }, this.config.alternateSecondVariant ? {
        USERHISTORY: formatText('typeahead.ess.history') || 'Recent searches',
        ALTERNATE: formatText('typeahead.ess.alternate') || 'People also searched'
      } : {
        ALTERNATE: formatText('typeahead.ess.alternate') || 'People also searched',
        USERHISTORY: formatText('typeahead.ess.history') || 'Recent searches'
      });
    }
  }, {
    key: "categorizeOnFocusResponse",
    value: function categorizeOnFocusResponse(typeaheadResults, makeAltDestCall) {
      if (typeaheadResults && typeaheadResults.length > 0) {
        var element0 = typeaheadResults[0];
        if (element0.data.category === 'ALTERNATE' || element0.data.category === 'CURRENTLOCATION' || element0.data.category === 'POPULAR' || element0.data.category === 'DRIVABLE' && this.config.drivable || element0.data.category === 'USERHISTORY' && this.config.alternate && makeAltDestCall) {
          var resultsByCategory = new Map();
          var finalResults = [];
          var focusCategories = this.onFocusCategories();
          var trueIndex = 0;
          typeaheadResults.forEach(function (element) {
            if (element.data.category) {
              var categoryName = element.data.category;
              if (!resultsByCategory[categoryName]) {
                resultsByCategory[categoryName] = [];
              }
              resultsByCategory[categoryName].push(element);
            }
          });
          for (var _i2 = 0, _Object$entries2 = Object.entries(focusCategories); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              category = _Object$entries2$_i[0],
              heading = _Object$entries2$_i[1];
            var categorizedResult = resultsByCategory[category];
            if (categorizedResult && categorizedResult.length > 0) {
              // eslint-disable-next-line no-loop-func
              categorizedResult.forEach(function (typeaheadResult) {
                // eslint-disable-next-line no-param-reassign
                typeaheadResult.data.index = trueIndex;
                // eslint-disable-next-line no-param-reassign
                typeaheadResult.data.displayType = 'CATEGORIZED';
                trueIndex += 1;
              });
              var resultByCategory = {
                heading: heading,
                typeaheadResults: categorizedResult
              };
              finalResults.push(resultByCategory);
            }
          }
          if (makeAltDestCall || this.config.showCurrentLocation) {
            var _this$config$logRespo, _this$config2;
            // Log the typeahead response in the logger with the updated order
            this.response.sr = finalResults.flatMap(function (categorizedResult) {
              return categorizedResult.typeaheadResults.map(function (typeaheadResult) {
                return typeaheadResult.data;
              });
            });
            (_this$config$logRespo = (_this$config2 = this.config).logResponse) === null || _this$config$logRespo === void 0 || _this$config$logRespo.call(_this$config2, this.response);
          }
          return finalResults;
        }
      }
      return typeaheadResults;
    }
  }, {
    key: "onItemSelection",
    value: function onItemSelection(data) {
      if ((data === null || data === void 0 ? void 0 : data.type) === exports.TypeaheadLocationType.CURRENT_LOCATION) {
        return this.handleCurrentLocationSelection(data);
      }
      if (this.config.fetchLocation && (data === null || data === void 0 ? void 0 : data.type) === exports.TypeaheadLocationType.ADDRESS && data.category === GOOGLEMAPS_CATEGORY && data.sourceId && typeof this.thirdPartyFallbackAdapter.fetchLocation === 'function') {
        return this.fillLocation(this.thirdPartyFallbackAdapter.fetchLocation.bind(this.thirdPartyFallbackAdapter), data.sourceId, data);
      }
      return Promise.resolve(data);
    }
  }, {
    key: "handleCurrentLocationSelection",
    value: function handleCurrentLocationSelection(data) {
      var _this9 = this;
      if (this.isGeoLocationAllowed) {
        return this.readCurrentLocation().then(function (_ref3) {
          var _ref3$coords = _ref3.coords,
            latitude = _ref3$coords.latitude,
            longitude = _ref3$coords.longitude;
          return _objectSpread(_objectSpread({}, data), {}, {
            location: {
              lat: latitude.toFixed(5),
              "long": longitude.toFixed(5)
            }
          });
        })["catch"](function (error) {
          _this9.isGeoLocationAllowed = false;
          throw error;
        });
      }
      var message = this.l10n.formatText('typeahead.currentLocation.blocked.message');
      // eslint-disable-next-line no-alert
      window.alert(message);
      return Promise.reject(message);
    }
  }, {
    key: "fillLocation",
    value: function fillLocation(fetchLocation, placeId, data) {
      return fetchLocation(placeId).then(function (location) {
        if (location) {
          var lat = location.lat,
            lng = location.lng;
          return _objectSpread({
            location: {
              lat: lat,
              "long": lng
            }
          }, data);
        }
        return data;
      });
    }
    /*
     * Note: Position is a global TypeScript interface representing the response to the navigator.geolocation call.
     * https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.position.html
     */
  }, {
    key: "readCurrentLocation",
    value: function readCurrentLocation() {
      return new Promise(function (resolve, reject) {
        window.navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    }
  }, {
    key: "handleEssResponse",
    value: function handleEssResponse(json) {
      // eslint-disable-next-line no-param-reassign
      json.sr = json.sr || json.suggestions || [];
      if (!this.thirdPartyFallbackAdapter) {
        this.setThirdPartyAdapter();
      }
      if (this.thirdPartyFallbackAdapter && (json.rc === 'GOOGLE_AUTOCOMPLETE' || json.rc === 'ADDRESS_AUTOCOMPLETE')) {
        return this.thirdPartyFallbackAdapter.fetchResults(json);
      }
      return Promise.resolve(json);
    }
  }, {
    key: "setThirdPartyAdapter",
    value: function setThirdPartyAdapter() {
      var fallbackAdapterRequested = ThirdPartyAdapterFactory.filterThirdPartyAdapterFromEssConfig(this.config.features.split('|'));
      var fallbackAdapter;
      if (fallbackAdapterRequested.length > 0) {
        var fallbackAdapterKey = fallbackAdapterRequested[0];
        fallbackAdapter = ThirdPartyAdapterFactory.getInstance(fallbackAdapterKey, this.config.locale, fallbackAdapterKey === 'google' ? this.config.googleApiKey : undefined, fallbackAdapterKey === 'google' ? this.config.googleApiVersion : undefined);
        this.thirdPartyFallbackAdapter = fallbackAdapter;
      }
    }
  }, {
    key: "logResponse",
    value: function logResponse(results) {
      var _this$config$logRespo2, _this$config3;
      (_this$config$logRespo2 = (_this$config3 = this.config).logResponse) === null || _this$config$logRespo2 === void 0 || _this$config$logRespo2.call(_this$config3, results);
      this.response = results;
      return Promise.resolve(results);
    }
  }, {
    key: "adaptResponseToTypeaheadResults",
    value: function adaptResponseToTypeaheadResults(results, term, historyDetail, historyDetailVariant) {
      var _this10 = this;
      var getOneRoomLodgingString = function getOneRoomLodgingString(formatText, rooms, travelers, excludeRoomsLabelForRecentHistory) {
        return excludeRoomsLabelForRecentHistory ? formatText('typeahead.recentHistory.travelers', travelers) : historyDetailVariant ? formatText('typeahead.recentHistory.travelersRooms', travelers, rooms) : formatText('typeahead.recentHistory.roomsTravelers', rooms, travelers);
      };
      var getListingTitle = function getListingTitle(result) {
        return (result === null || result === void 0 ? void 0 : result.type) === 'LISTING' && result.listingProps ? result.listingProps.headline : undefined;
      };
      var getListingSubText = function getListingSubText(result) {
        return (result === null || result === void 0 ? void 0 : result.type) === 'LISTING' && result.listingProps ? {
          subtext: "".concat(result.listingProps.listingId, " - ").concat(result.listingProps.baseLocation)
        } : undefined;
      };
      var getSubtext = function getSubtext(category, data) {
        var subtextString;
        var subtextA11yLabel;
        if (category === 'USERHISTORY' && historyDetail && typeof _this10.l10n !== 'undefined' && data && data.searchDetail && data.searchDetail.lob && !term) {
          var summaryString = '';
          var detail = data.searchDetail;
          var _this10$l10n = _this10.l10n,
            formatDateString = _this10$l10n.formatDateString,
            formatText = _this10$l10n.formatText;
          var rooms = detail.roomCount;
          var lineOfBusiness = detail.lob;
          var travelers = data.searchDetail.totalTravelerCount ? Number(data.searchDetail.totalTravelerCount) : null;
          if (data.searchDetail.startDate && data.searchDetail.endDate) {
            // `TimezoneOffset` is used to prevent the days being off by one day because of local time conversion
            var checkinDate = new Date(detail.startDate);
            var checkinTimezoneOffset = checkinDate.getTimezoneOffset() * 60000;
            var checkinString = formatDateString(new Date(checkinDate.getTime() + checkinTimezoneOffset), {
              skeleton: 'MMMd'
            });
            var checkoutDate = new Date(detail.endDate);
            var checkoutTimezoneOffset = checkoutDate.getTimezoneOffset() * 60000;
            var checkoutString = formatDateString(new Date(checkoutDate.getTime() + checkoutTimezoneOffset), {
              skeleton: 'MMMd'
            });
            // Dates are in milliseconds, so divide by ms/day to get number of days/nights
            var nights = (Number(detail.endDate) - Number(detail.startDate)) / 86400000;
            var nightsString = formatText('datePicker.nightSummary', nights);
            subtextString = "".concat(checkinString, " - ").concat(checkoutString);
            subtextA11yLabel = formatText('typeahead.recentHistory.aceessibility.dates', checkinString, checkoutString);
            if (rooms === 1 && (lineOfBusiness === 'Lodging' || lineOfBusiness === 'Package')) {
              summaryString = getOneRoomLodgingString(formatText, rooms, travelers, _this10.config.excludeRoomsLabelForRecentHistory);
              if (historyDetailVariant) {
                subtextString = "".concat(checkinString, " - ").concat(checkoutString, " \u2022 ").concat(summaryString);
                subtextA11yLabel = subtextA11yLabel.concat(", ".concat(summaryString));
              } else {
                subtextString = "".concat(checkinString, " - ").concat(checkoutString, " | ").concat(nightsString, " | ").concat(summaryString);
                subtextA11yLabel = subtextA11yLabel.concat(", ".concat(nightsString, ", ").concat(summaryString));
              }
            } else if (lineOfBusiness === 'Lodging' || lineOfBusiness === 'Package') {
              if (historyDetailVariant) {
                subtextString = "".concat(checkinString, " - ").concat(checkoutString);
              } else {
                subtextString = "".concat(checkinString, " - ").concat(checkoutString, " | ").concat(nightsString);
                subtextA11yLabel = subtextA11yLabel.concat(", ".concat(nightsString));
              }
            }
          } else if (!data.searchDetail.startDate && !data.searchDetail.endDate) {
            if (rooms === 1 && (lineOfBusiness === 'Lodging' || lineOfBusiness === 'Package')) {
              subtextString = getOneRoomLodgingString(formatText, rooms, travelers, _this10.config.excludeRoomsLabelForRecentHistory);
            }
          }
        }
        return {
          subtext: subtextString,
          a11yLabel: subtextA11yLabel
        };
      };
      var parseDisplayText = function parseDisplayText(result) {
        var _result$regionNames2, _result$names2, _result$regionNames3;
        var _ref4 = getSubtext(result.category, result) || getListingSubText(result),
          subtext = _ref4.subtext,
          a11yLabel = _ref4.a11yLabel;
        if (_this10.config.features.indexOf(EssFeatures.CONSISTENT_DISPLAY) < 0) {
          var _result$regionNames, _result$names;
          var oneLineDisplayText = ((_result$regionNames = result.regionNames) === null || _result$regionNames === void 0 ? void 0 : _result$regionNames.displayName) || ((_result$names = result.names) === null || _result$names === void 0 ? void 0 : _result$names.displayName) || getListingTitle(result);
          return {
            primaryText: oneLineDisplayText,
            subtext: subtext,
            a11yLabel: a11yLabel
          };
        }
        var firstLine = ((_result$regionNames2 = result.regionNames) === null || _result$regionNames2 === void 0 ? void 0 : _result$regionNames2.primaryDisplayName) || ((_result$names2 = result.names) === null || _result$names2 === void 0 ? void 0 : _result$names2.displayName) || getListingTitle(result);
        if (subtext) {
          return {
            primaryText: "".concat(firstLine),
            subtext: subtext,
            a11yLabel: a11yLabel
          };
        }
        var secondLine = ((_result$regionNames3 = result.regionNames) === null || _result$regionNames3 === void 0 ? void 0 : _result$regionNames3.secondaryDisplayName) || getListingSubText(result) || '';
        return {
          primaryText: "".concat(firstLine),
          subtext: secondLine
        };
      };
      // eslint-disable-next-line max-params
      var getIcon = function getIcon(type, subType, isChild, isNearby, category) {
        if (type === 'AIRLINE') {
          return '';
        }
        if (isChild && !isNearby) {
          return 'subdirectory_arrow_right';
        }
        if (category === 'USERHISTORY') {
          return 'history';
        }
        if (_this10.config.lob === 'FLIGHTS') {
          return 'lob_flights';
        }
        switch (type) {
          case 'HOTEL':
            return 'lob_hotels';
          case 'AIRPORT':
            return 'lob_flights';
          case 'ADDRESS':
            if (subType === 'RENTALLOCATION') {
              return 'lob_cars';
            }
            return 'place';
          case 'METROSTATION':
          case 'TRAINSTATION':
            return 'train';
          default:
            return 'place';
        }
      };
      var generateNewResults = function generateNewResults(newResults, result, index) {
        var _result$ids, _result$regionNames4, _result$regionNames5, _result$regionNames6, _result$listingProps, _result$ids2, _result$regionNames7, _result$regionNames8, _result$regionNames9, _result$listingProps2, _result$names3, _result$filterRefinem;
        var isNearby = result.hierarchyInfo && result.hierarchyInfo.relation && result.hierarchyInfo.relation.indexOf('nearby') > -1;
        var isChild = result.hierarchyInfo && result.hierarchyInfo.relation && result.hierarchyInfo.relation.indexOf('child') > -1 || isNearby;
        var _parseDisplayText = parseDisplayText(result),
          primaryText = _parseDisplayText.primaryText,
          subtext = _parseDisplayText.subtext,
          a11yLabel = _parseDisplayText.a11yLabel;
        var newResult = _objectSpread(_objectSpread({
          data: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, result.category ? {
            category: result.category
          } : {}), !term && result.searchDetail ? {
            searchDetail: result.searchDetail
          } : {}), result.userHistoryType ? {
            userHistoryType: result.userHistoryType
          } : {}), (_result$ids = result.ids) !== null && _result$ids !== void 0 && _result$ids.id ? {
            id: result.ids.id
          } : {}), result.coordinates ? {
            location: {
              lat: result.coordinates.lat,
              "long": result.coordinates["long"]
            }
          } : {}), result.regionId ? {
            regionId: result.regionId
          } : result.gaiaId ? {
            regionId: result.gaiaId
          } : {}), result.cityId ? {
            cityId: result.cityId
          } : {}), result.regionNames ? {
            regionNames: result.regionNames
          } : {}), result.type ? {
            type: result.type
          } : {}), result.subtype ? {
            subtype: result.subtype
          } : {}), result.hotelId ? {
            selected: result.hotelId
          } : {}), result.hierarchyInfo ? {
            hierarchyInfo: result.hierarchyInfo
          } : {}), result.type === 'LISTING' && result.listingProps ? {
            listing: result.listingProps
          } : {}), result.sourceId ? {
            sourceId: result.sourceId
          } : {}), result.essId ? {
            essId: {
              sourceId: result.essId.sourceId,
              sourceName: result.essId.sourceName
            }
          } : {}), {
            dest: _this10.config.dest
          }), {
            index: index + 1
          }),
          icon: getIcon(result.type || result.domainId, result.subtype, isChild, isNearby, result.category)
        }, isChild ? {
          isChild: true
        } : {}), {}, {
          imageUrl: result.imageUrl,
          name: primaryText,
          subtext: subtext,
          a11yLabel: a11yLabel,
          title: ((_result$regionNames4 = result.regionNames) === null || _result$regionNames4 === void 0 ? void 0 : _result$regionNames4.lastSearchName) || ((_result$regionNames5 = result.regionNames) === null || _result$regionNames5 === void 0 ? void 0 : _result$regionNames5.shortName) || ((_result$regionNames6 = result.regionNames) === null || _result$regionNames6 === void 0 ? void 0 : _result$regionNames6.fullName) || ((_result$listingProps = result.listingProps) === null || _result$listingProps === void 0 ? void 0 : _result$listingProps.listingId) || ((_result$ids2 = result.ids) === null || _result$ids2 === void 0 ? void 0 : _result$ids2.id),
          value: ((_result$regionNames7 = result.regionNames) === null || _result$regionNames7 === void 0 ? void 0 : _result$regionNames7.lastSearchName) || ((_result$regionNames8 = result.regionNames) === null || _result$regionNames8 === void 0 ? void 0 : _result$regionNames8.shortName) || ((_result$regionNames9 = result.regionNames) === null || _result$regionNames9 === void 0 ? void 0 : _result$regionNames9.fullName) || ((_result$listingProps2 = result.listingProps) === null || _result$listingProps2 === void 0 ? void 0 : _result$listingProps2.listingId) || ((_result$names3 = result.names) === null || _result$names3 === void 0 ? void 0 : _result$names3.displayName)
        });
        newResults.push(newResult);
        if (result !== null && result !== void 0 && result.filterRefinements && (result === null || result === void 0 || (_result$filterRefinem = result.filterRefinements) === null || _result$filterRefinem === void 0 ? void 0 : _result$filterRefinem.length) > 0) {
          var _result$filterRefinem2;
          result === null || result === void 0 || (_result$filterRefinem2 = result.filterRefinements.find(function (item) {
            var _item$category, _item$category2;
            return (item === null || item === void 0 || (_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.legacyId) === 'popularFilter' || (item === null || item === void 0 || (_item$category2 = item.category) === null || _item$category2 === void 0 ? void 0 : _item$category2.externalId) === 'popular_group';
          })) === null || _result$filterRefinem2 === void 0 || (_result$filterRefinem2 = _result$filterRefinem2.arrayOfValues) === null || _result$filterRefinem2 === void 0 || _result$filterRefinem2.forEach(function (popularFilter) {
            newResults.push(_objectSpread(_objectSpread({}, newResult), {}, {
              data: _objectSpread(_objectSpread({}, newResult.data), {}, {
                popularFilter: [popularFilter]
              }),
              subtext: "<strong>".concat(popularFilter === null || popularFilter === void 0 ? void 0 : popularFilter.displayName, "</strong>"),
              icon: 'subdirectory_arrow_right'
            }));
          });
        }
        return newResults;
      };
      var baseResults = term === '' && this.shouldShowCurrentLocation() ? [this.getCurrentLocationItem()] : [];
      var adapt = function adapt(json) {
        var _json$sr, _json$sr$reduce;
        return ((_json$sr = json.sr) === null || _json$sr === void 0 || (_json$sr$reduce = _json$sr.reduce) === null || _json$sr$reduce === void 0 ? void 0 : _json$sr$reduce.call(_json$sr, generateNewResults, baseResults)) || baseResults;
      };
      return adapt(results);
    }
    /**
     * The Current Location feature is only shown on browsers which support it,
     * even when the showCurrentLocation config is set to true.
     */
  }, {
    key: "shouldShowCurrentLocation",
    value: function shouldShowCurrentLocation() {
      return Boolean(this.config.showCurrentLocation && 'geolocation' in navigator);
    }
    /**
     * The "Current location" result item is not returned by the back-end EGTA/ESS API, it is instead created
     * on the front-end and added to the beginning of the results when needed.
     */
  }, {
    key: "getCurrentLocationItem",
    value: function getCurrentLocationItem() {
      var label = this.isGeoLocationAllowed ? this.l10n.formatText('typeahead.currentLocation.available.item') : this.l10n.formatText('typeahead.currentLocation.blocked.item');
      return {
        data: {
          category: 'CURRENTLOCATION',
          hierarchyInfo: {
            relation: ['current']
          },
          index: -1,
          enabled: this.isGeoLocationAllowed,
          regionNames: {
            fullName: 'CurrentLocation'
          },
          type: exports.TypeaheadLocationType.CURRENT_LOCATION
        },
        icon: 'my_location',
        name: label,
        title: label,
        value: label
      };
    }
  }, {
    key: "getBrowser",
    value: function getBrowser(ua) {
      var tem;
      var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        return 'IE';
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if (tem !== null) {
          return tem.slice(1, -1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      tem = ua.match(/version\/(\d+)/i);
      if (tem !== null) {
        M.splice(1, 1, tem[1]);
      }
      return M[0];
    }
  }, {
    key: "getDevice",
    value: function getDevice(ua) {
      if (/iPad|Transformer|ME173X|KOOF|Nook|IMM76D|Nexus 10|Nexus 7|Tablet/i.test(ua) || /HP Slate|PG09410|PG41200|Mediapad|Kindle|Tab|Xoom|TegraNote|SCH-I800/i.test(ua)) {
        return 'Tablet';
      }
      if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
        return 'Mobile';
      }
      return 'Desktop';
    }
  }]);
}();
var getSizeOfTypeaheadResults = function getSizeOfTypeaheadResults(typeaheadResults) {
  /* eslint-disable-next-line default-case */
  switch (typeaheadResults.type) {
    case 'categorized':
      return typeaheadResults.items.reduce(function (sum, currentItem) {
        return sum + currentItem.typeaheadResults.length;
      }, 0);
    case 'uncategorized':
      return typeaheadResults.items.length;
  }
};
var filterTypeaheadResults = function filterTypeaheadResults(typeaheadResults, values) {
  /* eslint-disable-next-line default-case */
  switch (typeaheadResults.type) {
    case 'categorized':
      return _objectSpread(_objectSpread({}, typeaheadResults), {}, {
        items: typeaheadResults.items.map(function (category) {
          return _objectSpread(_objectSpread({}, category), {}, {
            typeaheadResults: category.typeaheadResults.filter(function (item) {
              return !values.includes(item.value);
            })
          });
        })
      });
    case 'uncategorized':
      return _objectSpread(_objectSpread({}, typeaheadResults), {}, {
        items: typeaheadResults.items.filter(function (item) {
          return !values.includes(item.value);
        })
      });
  }
};
var getSelectedResult = function getSelectedResult(typeaheadResults, index) {
  /* eslint-disable-next-line default-case */
  switch (typeaheadResults.type) {
    case 'categorized':
      {
        return typeaheadResults.items.reduce(function (items, currentItem) {
          items.push.apply(items, _toConsumableArray(currentItem.typeaheadResults));
          return items;
        }, [])[index];
      }
    case 'uncategorized':
      return typeaheadResults.items[index];
  }
};

/* istanbul ignore file */
var appendQueryParam = function appendQueryParam(url, key, value) {
  if (value === '' || value === null) {
    return url;
  }
  var punctuation = /\?/.test(url) ? '&' : '?';
  var query = encodeURIComponent(key);
  if (value !== undefined && value !== '') {
    query = query.concat('=', encodeURIComponent(value));
  }
  return url + punctuation + query;
};
var appendQueryObject = function appendQueryObject(url, queryObject) {
  if (queryObject === null || queryObject === undefined) {
    return url;
  }
  var result = url;
  Object.keys(queryObject).forEach(function (key) {
    var value = queryObject[key];
    if (value === undefined) {
      return;
    }
    result = appendQueryParam(result, key, value);
  });
  return result;
};
exports.ESSAdapter = ESSAdapter;
exports.GOOGLEMAPS_CATEGORY = GOOGLEMAPS_CATEGORY;
exports.GoogleAdapter = GoogleAdapter;
exports.ThirdPartyAdapter = ThirdPartyAdapter;
exports.ThirdPartyAdapterFactory = ThirdPartyAdapterFactory;
exports.appendQueryObject = appendQueryObject;
exports.appendQueryParam = appendQueryParam;
exports.filterTypeaheadResults = filterTypeaheadResults;
exports.getSelectedResult = getSelectedResult;
exports.getSizeOfTypeaheadResults = getSizeOfTypeaheadResults;
//# sourceMappingURL=index-chunk.js.map
